import { api } from "@/lib/api";

const g = (p, params) => api.get(p, { params }).then((r) => r.data);
const post = (p, body) => api.post(p, body).then((r) => r.data);
const B = "/admin/bid-center";
const G = "/admin/groups";

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join("; ") : "Something went wrong";
};

export const bidDashboard = () => g(`${B}/dashboard`);
export const bidActivity = (params) => g(`${B}/activity`, params);
export const reviewQueue = () => g(`${B}/review-queue`);
export const classifyBid = (id, body) => post(`${B}/bids/${id}/classify`, body);
export const authorizeAuction = (id, reason) => post(`${B}/auctions/${id}/authorize`, { reason });
export const notifSettings = () => g(`${B}/notifications/settings`);
export const saveNotifSettings = (body) => api.put(`${B}/notifications/settings`, body).then((r) => r.data);
export const notifications = () => g(`${B}/notifications`);
export const smsStatus = () => g("/admin/sms/status");
export const smsVerify = () => post("/admin/sms/verify", {});
export const smsControl = (body) => api.put("/admin/sms/control", body).then((r) => r.data);
export const smsCredentials = (body) => api.put("/admin/sms/credentials", body).then((r) => r.data);
export const smsTest = (body) => post("/admin/sms/test", body);
export const smsTests = () => g("/admin/sms/tests");
export const smsRefresh = (id) => post(`/admin/sms/tests/${id}/refresh`, {});
export const markRead = (id) => post(`${B}/notifications/${id}/read`);

export const listGroups = () => g(G);
export const createGroup = (body) => post(G, body);
export const updateGroup = (id, body) => api.put(`${G}/${id}`, body).then((r) => r.data);
export const listPresets = () => g(`${G}/presets/all`);
export const savePreset = (body) => post(`${G}/presets`, body);
export const deletePreset = (id) => api.delete(`${G}/presets/${id}`).then((r) => r.data);
export const horseDistribution = (hid) => g(`${G}/horse/${hid}`);
export const recommendGroups = (hid) => g(`${G}/horse/${hid}/recommendations`);
export const addDistribution = (hid, body) => post(`${G}/horse/${hid}/distribution`, body);
export const groupOverview = () => g(`${G}/overview`);
export const updateDistribution = (id, body) => api.patch(`${G}/distributions/${id}`, body).then((r) => r.data);

export const money = (a, c) => (a == null ? "—" : `$${Number(a).toLocaleString("en-CA", { maximumFractionDigits: 2 })} ${c || ""}`.trim());
